export const isApp = (isAppContextQueryParam?: string) =>
  isAppContextQueryParam === 'true'
